import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { FallingLeafAnimation } from '../../animations/FallingLeafAnimation';

// types
//-----------------------------------------------------------------------------
export type LeafFallingEffectOptions = {
  position: PositionType;
  leafIndex: number;
};

/*
    leaf falling effect
*/
export class LeafFallingEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  private readonly _index: number;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: LeafFallingEffectOptions) {
    this._scene = scene;
    this._position = options.position;
    this._index = options.leafIndex;
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create  animation
    const animation = new FallingLeafAnimation({
      leafIndex: this._index,
    });
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
